import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const FormGeneratorFieldWrapperCDS = ({
  additionalTitle,
  additionalContainerProps,
  additionalTitleProps,
  FieldComponent,
  ...props
}) => (
  <>
    {additionalTitle ? (
      <Box {...additionalContainerProps}>
        <Typography {...additionalTitleProps} variant="regular14">
          {additionalTitle}
        </Typography>

        <FieldComponent {...props} />
      </Box>
    ) : (
      <FieldComponent {...props} />
    )}
  </>
);

FormGeneratorFieldWrapperCDS.propTypes = {
  FieldComponent: PropTypes.elementType.isRequired,
  additionalTitle: PropTypes.node,
  additionalContainerProps: PropTypes.object,
  additionalTitleProps: PropTypes.object,
};

export default memo(FormGeneratorFieldWrapperCDS);
